import React from 'react';
import useDataDocuments from '../../hooks/useDataDocuments';
import { Box, CircularProgress, Typography } from '@mui/material';
import CardDoc from './CardDoc';
import CardSkeleton from './CardSkeleton';
import NewPreloader from '../Common/NewPreloader';

const List = () => {
    const { data, isLoading } = useDataDocuments();
    return (
        <Box display="flex" flexDirection="column">
            {isLoading ? (
                <Box sx={{display:'flex', justifyContent:'center', alignItems:'center', mt:'100px'}}>
                    <NewPreloader/>
                </Box>
                // [...Array(8)].map((_, index) => (
                //     <CardSkeleton key={index} />
                // ))
            ) : (
                <>
                    {data?.map((item) => (
                        <CardDoc key={item.documentNumber} item={item} />
                    ))}
                    {data && data.length === 0 && (
                        <Box 
                            mt="auto" 
                            display="flex" 
                            justifyContent="center" 
                            alignItems="center"
                            width={'100%'}
                        >
                            <Box sx={{position:'absolute', bottom:'90px'}}>
                                <Box>
                                    <Typography textAlign={'center'} color='#79A3B4' fontWeight={700} fontSize={'13px'}>
                                        אופס!
                                    </Typography>
                                    <Typography textAlign={'center'} color='#79A3B4' fontWeight={400} fontSize={'13px'}>
                                        נראה שעוד אין פה כלום
                                    </Typography>
                                    <img 
                                        src={`${process.env.REACT_APP_MEDIA}/emptyDoc.png`} 
                                        alt="Empty Document" 
                                        style={{ maxWidth: '100%', height: 'auto' }}
                                    />
                                </Box>
                            </Box>
                        </Box>
                    )}
                </>
            )}
        </Box>
    );
};

export default List;
